module.exports = __webpack_public_path__ + "static/media/ionicon.d3476c18.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/ionicon/ionicon.ttf?phty4a
 ** module id = 179
 ** module chunks = 0
 **/